module.exports = __webpack_public_path__ + "static/dust_of_sneezing_and_choking-3525e814aefae1fd7af5950abe321add.jpeg";